import './router.scss';
/**
 * This component adds the view where all the other routed component/containers will be injected.
 * @ngesdoc component
 * @ngname router
 * @ngmodule root
 * @ngtransclude
 */
export default {
  template: `
    <div class="appRouter">
      <div class="appRouter_view" ng-view></div>
    </div>
  `,
  transclude: true,
};
